import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aa06332"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "page container-lg container-fluid" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Approval of innovation proposal"),
  /*#__PURE__*/_createElementVNode("h6", { class: "align-self-end me-4" }, "Health Informatics")
], -1))
const _hoisted_5 = { class: "mt-4 mb-5" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "p_heading" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "my-3" }, "Submitted Innovation Proposal", -1))
const _hoisted_9 = { class: "my-2" }
const _hoisted_10 = { class: "ms-5 p_heading" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "my-3" }, "Health Priority Needs", -1))
const _hoisted_12 = { class: "my-2" }
const _hoisted_13 = { class: "h-100 d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "me-2 bi bi-printer-fill" }, null, -1))
const _hoisted_15 = { class: "grey_section py-4" }
const _hoisted_16 = { class: "container-lg container-fluid" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Description of Health Need/Challenge", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Solution Description", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Target End User:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Funds raised till date", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Personal Description", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Challenges", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Potential", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Uniqueness of System", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Critical Next Steps", -1))
const _hoisted_26 = { class: "attached_files" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Attached files", -1))
const _hoisted_28 = {
  type: "number",
  class: "text-primary"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "container-lg container-fluid my-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "comments" }, [
  /*#__PURE__*/_createTextVNode("Comments/Suggestions"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1))
const _hoisted_34 = { class: "w-100 text-muted d-flex justify-content-end mr-3" }
const _hoisted_35 = { class: "w-100 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_FormModal = _resolveComponent("FormModal")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.ApproveId === '')
      ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.data.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Skeleton, {
            width: "100%",
            style: {"height":"20rem"},
            class: "mb-4"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            style: {"height":"30rem"},
            class: "mb-3"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            style: {"height":"10rem"},
            class: "mb-3"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.data.length !== 0)
        ? (_openBlock(), _createElementBlock("main", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("section", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.data?.proposal_details?.solution_title), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.need?.title), 1),
                  _createElementVNode("div", null, [
                    _createVNode(_component_Button, {
                      onClick: _withModifiers(_ctx.gotoNeed, ["prevent"]),
                      class: "p-button-text p-button-raised",
                      label: "Click here to read on the health priority needs",
                      "aria-label": "Goto Needs"
                    }, null, 8, ["onClick"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Button, {
                  class: "p-button-text",
                  label: "Print to PDF",
                  onclick: "window.print()",
                  style: {"margin-left":"1rem"},
                  "aria-label": "Print"
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", null, [
          _hoisted_17,
          _createElementVNode("p", null, _toDisplayString(_ctx.need.description), 1),
          _hoisted_18,
          _createElementVNode("p", null, _toDisplayString(_ctx.data?.solution_description), 1)
        ]),
        _hoisted_19,
        _createElementVNode("p", null, _toDisplayString(_ctx.need.target_users), 1),
        _hoisted_20,
        _createElementVNode("p", null, _toDisplayString(_ctx.data?.funds_raised), 1),
        _hoisted_21,
        _createElementVNode("p", null, _toDisplayString(_ctx.data?.personal_description), 1),
        _hoisted_22,
        _createElementVNode("p", null, _toDisplayString(_ctx.data?.scale_challenges), 1),
        _hoisted_23,
        _createElementVNode("p", null, _toDisplayString(_ctx.data?.scale_potential), 1),
        _hoisted_24,
        _createElementVNode("p", null, _toDisplayString(_ctx.data?.solution_uniqueness), 1),
        _hoisted_25,
        _createElementVNode("p", null, _toDisplayString(_ctx.data?.critical_next_steps), 1),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("ol", _hoisted_28, [
            (_ctx.data?.proposal_details?.reference_letter_doc)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
              _ctx.handleFile(_ctx.data?.proposal_details?.reference_letter_doc)
            ), ["prevent"]))
                }, [
                  _createElementVNode("img", {
                    src: 
                require(`@/assets/placeholder/${_ctx.getFileExt(
                  _ctx.data?.proposal_details?.reference_letter_doc
                )}.svg`)
              ,
                    alt: "placeholder_img",
                    width: "15"
                  }, null, 8, _hoisted_29),
                  _createTextVNode(" " + _toDisplayString(_ctx.data?.proposal_details?.reference_letter_doc &&
              _ctx.getFileName(_ctx.data?.proposal_details?.reference_letter_doc)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.data?.proposal_details?.tech_specs_docs)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleFile(_ctx.data?.proposal_details?.tech_specs_docs)), ["prevent"]))
                }, [
                  _createElementVNode("img", {
                    src: 
                require(`@/assets/placeholder/${_ctx.getFileExt(
                  _ctx.data?.proposal_details?.tech_specs_docs
                )}.svg`)
              ,
                    alt: "placeholder_img",
                    width: "15"
                  }, null, 8, _hoisted_30),
                  _createTextVNode(" " + _toDisplayString(_ctx.data?.proposal_details?.tech_specs_docs &&
              _ctx.getFileName(_ctx.data?.proposal_details?.tech_specs_docs)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.data?.proposal_details?.video_upload)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 2,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleFile(_ctx.data?.proposal_details?.video_upload)), ["prevent"]))
                }, [
                  _createElementVNode("img", {
                    src: 
                require(`@/assets/placeholder/${_ctx.getFileExt(
                  _ctx.data?.proposal_details?.video_upload
                )}.svg`)
              ,
                    alt: "placeholder_img",
                    width: "15"
                  }, null, 8, _hoisted_31),
                  _createTextVNode(" " + _toDisplayString(_ctx.data?.proposal_details?.video_upload &&
              _ctx.getFileName(_ctx.data?.proposal_details?.video_upload)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("form", {
        ref: "approveInnovation",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", null, [
          _hoisted_33,
          _createVNode(_component_Textarea, {
            label: "Comments",
            id: "comments",
            name: "comments",
            placeholder: "Enter your comment here...",
            modelValue: _ctx.comments,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.comments) = $event)),
            rows: 5,
            cols: 50,
            class: "w-100",
            maxlength: "200"
          }, null, 8, ["modelValue"]),
          _createElementVNode("small", _hoisted_34, _toDisplayString(_ctx.comments.length) + "/200", 1)
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_Button, {
            disabled: _ctx.loading1,
            icon: _ctx.loading1 ? 'pi pi-spin pi-spinner px-2' : '',
            onClick: _withModifiers(_ctx.reject, ["prevent"]),
            class: "p-button-danger",
            label: "Reject Proposal",
            style: {"margin-left":"1rem"},
            "aria-label": "Reject"
          }, null, 8, ["disabled", "icon", "onClick"]),
          _createVNode(_component_Button, {
            disabled: _ctx.loading,
            icon: _ctx.loading ? 'pi pi-spin pi-spinner px-2' : '',
            onClick: _withModifiers(_ctx.onSubmit, ["prevent"]),
            class: "p-button-primary",
            label: "Approve Proposal",
            style: {"margin-left":"1rem"},
            "aria-label": "Submit"
          }, null, 8, ["disabled", "icon", "onClick"])
        ])
      ], 544)
    ]),
    (_ctx.authStatus === false)
      ? (_openBlock(), _createBlock(_component_FormModal, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.ApproveId === '')
      ? (_openBlock(), _createBlock(_component_Footer, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}